// MSAL Configuration for Azure AD Authentication
import { LogLevel } from "@azure/msal-browser";

// Environment Variables (set in Azure App Service or .env)
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || "b3d4c6ff-b4b6-4947-8d2a-ab0ffc6a1f90";
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || "09ae0105-7a95-4914-b082-0ae30c3836fc";
const redirectUri = process.env.REACT_APP_REDIRECT_URI || window.location.origin;

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirectUri,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            // console.info(message);
            break;
          case LogLevel.Verbose:
            // console.debug(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes for login
export const loginRequest = {
  scopes: ["User.Read"],
};

// Scopes for Microsoft Graph API calls
export const graphScopes = {
  user: ["User.Read"],
  mail: ["Mail.Send"],
  sharepoint: ["Sites.ReadWrite.All", "Files.ReadWrite.All"],
};

// API endpoints
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
